export default {"src":"/_next/static/media/icon-sanctuary-conjunction.d0c7e34b.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};